import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ModalProvider } from './contexts/ModalContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <ModalProvider>
          <App />
        </ModalProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

// Capture install prompt ASAP (before React mounts consumers)
window.__pejmanDeferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pejmanDeferredPrompt = e;
  window.dispatchEvent(new CustomEvent('pejman-pwa-prompt'));
});

window.addEventListener('appinstalled', () => {
  window.__pejmanDeferredPrompt = null;
});

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('ServiceWorker registered:', registration.scope);
        // Check for updates periodically while app is open
        if (registration.update) {
          setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);
        }
      })
      .catch((error) => {
        console.log('ServiceWorker registration failed:', error);
      });
  });
}

reportWebVitals();
